<template>
  <div class="async-error"></div>
</template>
<script>
export default {
  name: 'AsyncError',
  mounted() {
    console.log('Error! Timeout exceeded!')
  }
}
</script>
<style lang="scss" scoped>
.async-error {
  text-align: center;
}
</style>